import { CrudService } from './CrudService';
import { resources } from '../resources';
import { CertificateTypeDto } from '../models/suppliers/CertificateTypeDto';
import { Args, AxiosConfig } from './BaseService';
import { AxiosPromise } from 'axios';

export class CertificateTypeService extends CrudService<CertificateTypeDto> {
  constructor() {
    super({
      create: resources.createCertificateType,
      update: resources.updateCertificateType,
      delete: resources.deleteCertificateType,
      idKey: 'certificateTypeId',
    });
  }

  public queryCertificateTypes(certificateId: string, args?: Args, options: AxiosConfig = {}): AxiosPromise<CertificateTypeDto[]> {
    return this.get<CertificateTypeDto[]>(resources.queryCertificateTypes, { certificateId, ...args }, options);
  }
}
